<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
        <el-breadcrumb-item>支付设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-container style="height: 400px;">
        <el-aside width="200px" height="100%" style="background-color: rgb(238, 241, 246)">
          <el-menu
            :default-active="activeType"
            class="el-menu-vertical-demo"
            @select="selectMenu">
            <el-menu-item index="1">
              <i class="el-icon-menu"></i>
              <span slot="title">微信支付</span>
            </el-menu-item>
            <el-menu-item index="2" >
              <i class="el-icon-setting"></i>
              <span slot="title">支付宝支付</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container v-if="visableMain=='1'">
          <el-header style="text-align: center; font-size: 12px">
            <el-row :gutter="12">
              <!-- <el-col :span="8" >
                <el-tooltip content="系统特约商户在’运营->特约商户‘申请，费率最低可达2‰" placement="top">
                  <el-card shadow="hover" @click.native="selectForm('1')" :class="[visableForm=='1'?'myactive':'']" >
                    系统特约商户（推荐）
                  </el-card>
                </el-tooltip>
              </el-col> -->
              <el-col :span="8" >
                <el-tooltip content="普通商户直接在微信支付后台申请" placement="top">
                  <el-card shadow="hover" @click.native="selectForm('2')" :class="[visableForm=='2'?'myactive':'']">
                    普通商户
                  </el-card>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-header>
          <el-main v-if="visableForm==2">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>普通商户设置</span>
              </div>              
              <el-form label-position="right" label-width="120px" :model="form">
                <el-form-item label="微信商户号">
                  <el-input v-model="form.weChat_Business_pay_Mchid"></el-input>
                </el-form-item>
                <el-form-item label="APIV3密钥">
                  <el-input v-model="form.weChat_Business_pay_ApiKey"></el-input>
                </el-form-item>
                <el-form-item label="微信支付序列号">
                  <el-input v-model="form.weChat_Business_pay_Cert_Path"></el-input>
                </el-form-item>                
                <el-form-item label="证书私钥">
                  <el-input v-model="form.weChat_Business_pay_Cert_PrivateKey"></el-input>
                </el-form-item>

                <el-form-item >
                  <el-col :span="11">
                    <el-button type="primary" @click="Save">确 定</el-button>
                  </el-col>
                </el-form-item>
              </el-form>
            </el-card>
          </el-main>
          <!-- <el-main v-if="visableForm==1">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>系统子商户设置</span>
              </div>              
              <el-form label-position="right" label-width="120px" :model="form">
                <el-form-item label="微信特约商户号">
                  <el-input v-model="form.weChat_Server_pay_Sub_Mchid"></el-input>
                </el-form-item>                
                <el-form-item >
                  <el-col :span="11">
                    <el-button type="primary" @click="Save">确 定</el-button>
                  </el-col>
                </el-form-item>
              </el-form>
            </el-card>
          </el-main> -->
        </el-container>
        <el-container v-if="visableMain=='2'">
          <el-main>
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>支付宝设置</span>
              </div>              
              <el-form label-position="right" label-width="100px" :model="form">
                <el-form-item label="支付宝商户号">
                  <el-input v-model="form.alipay_service_provider_id"></el-input>
                </el-form-item>
              </el-form>
            </el-card>
          </el-main>
        </el-container>

      </el-container>
    </div>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import qs from 'qs' 
  export default {
    data (){
      return {
        activeType:"1",
        name:'',
        visableForm:2,
        visableMain:1,
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        form:{},
      }
    },
    components:{   
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/System/PayParameter',         
          params:{          
          }
        }).then(function (resp) {
          that.form = resp.data.data
        })
        
      },
      selectMenu(index){
        this.visableMain = index
      },
      selectForm(index){
        this.visableForm = index
      },
      Save:function(){
        var that = this
        var dataObj = qs.stringify(that.form)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/System/SaveParameter',         
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },        
          data:dataObj
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.el-aside {
    color: #333;
  }
.myactive {
  border : 1px solid red
}
</style>